import { FC, useEffect, useState } from 'react';

import { useCoreViewerContext } from '../../../context/CoreViewerContext';

import styles from './index.module.scss';

export const StatusBarItemLoadingPercentage: FC = () => {
	const [loadingPercentage, setLoadingPercentage] = useState<number | undefined>(0);
	const [overviewLoaded, setOverviewLoaded] = useState(false);
	const {
		addLoadingPercentageChangedHandler,
		removeLoadingPercentageChangedHandler,
		addOverviewLoadingChangedHandler,
		removeOverviewLoadingChangedHandler,
	} = useCoreViewerContext();

	useEffect(() => {
		addLoadingPercentageChangedHandler('status-bar-item-loading-percentage', setLoadingPercentage);
		return (): void => {
			removeLoadingPercentageChangedHandler('status-bar-item-loading-percentage');
		};
	}, [addLoadingPercentageChangedHandler, removeLoadingPercentageChangedHandler]);

	useEffect(() => {
		addOverviewLoadingChangedHandler('status-bar-overview-loaded', setOverviewLoaded);
		return (): void => {
			removeOverviewLoadingChangedHandler('status-bar-overview-loaded');
		};
	}, [addOverviewLoadingChangedHandler, removeOverviewLoadingChangedHandler]);

	return (
		<div className={styles.item} data-statusbar-item-type="loading-percentage">
			{loadingPercentage !== undefined && loadingPercentage < 100 ? (
				<>
					Loading...<span className={styles.percentage}>{Math.round(loadingPercentage).toFixed(0)}</span>%
				</>
			) : overviewLoaded ? (
				<span data-loading-complete="">&nbsp;</span>
			) : (
				<span className={styles.percentage}>Loading overview...</span>
			)}
		</div>
	);
};
